import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { ShipmentAction } from '@shared-features/enums/shipment-action.enum';
import { DateRangeType } from '@shared/enums/date-range-type.enum';
import { TabIndex } from '@shared/enums/tab-index.enum';
import { TabGroup } from '@shared/enums/tab-group.enum';
import { SectionStateStatus } from '@shared/enums/section-state-status.enum';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ConfigConstant } from '@shared/constants/config.constant';
import { MatSort } from '@angular/material/sort';
import { SharedConstants } from '@shared/model/shared-constants';
import { TabModel } from '@shared/model/tab.model';
import { TransportationPaymentsStatus } from '@features/transportation-payments/enums/transportation-payments-status.enum';
import { FilterService } from '@shared/services/filter.service';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';
import { ShipmentSearchFields } from '@features/transportation-payments/utils/transportaions.enums';
import { ActivatedRoute } from '@angular/router';
import { TransportationPaymentsCommonService } from '@shared-features/services/transportation-payments-common.service';
import { Shipment } from '@shared-features/models/shipment';
import { TransportationPaymentDetails } from '@features/invoices/transportation-payment-details';
import { ColorPalette } from '@shared/enums';
import { ShipmentStatus } from '@shared-features/enums/shipment-status.enum';

@Component({
  selector: 'app-payment-shipments',
  templateUrl: './payment-shipments.component.html',
  styleUrls: ['./payment-shipments.component.scss'],
})
export class PaymentShipmentsComponent extends BaseComponent implements OnInit {
  dataSource = new MatTableDataSource<Shipment>();
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  sectionState: SectionStateStatus;
  sectionStateStatus = SectionStateStatus;
  ShipmentStatus: ShipmentStatus;

  public displayedColumns: string[] = [
    'action',
    'id',
    'shipmentStatus',
    'createdAt',
    'deliveryNoteRef',
    'customerName',
    'from',
    'to',
    'truckNo',
    'price',
    'tripCost',
    'multiDis',
    'waitingCharge',
    'fleetReturnCharge',
    'fleetWeightingFine',
    'fleetClearanceFees',
    'total',
    'driverName',
    'iqamaId',
    'driverPhone',
    'fleetType',
    'paymentStatus',
    'paymentDate',
    'bankRef',
    'rejectionReason',
    'assignedBy',
  ];
  colorShipmentPerStatus: { [n: string]: string } = {
    [ShipmentStatus.GoodsDelivered]: ColorPalette.Success,
    [ShipmentStatus.SHIPMENT_CREATED]: ColorPalette.Primary,
    [ShipmentStatus.Start]: ColorPalette.Primary,
    [ShipmentStatus.DRIVER_ASSIGNED]: ColorPalette.Warn,
    [ShipmentStatus.FLEET_ACCEPTED]: ColorPalette.Warn,
    [ShipmentStatus.ArrivePickupLocation]: 'custom',
  };
  colorPerStatus: { [n: string]: string } = {
    [TransportationPaymentsStatus.PAID]: ColorPalette.Success,
    [TransportationPaymentsStatus.REJECTED]: ColorPalette.Accent,
    [TransportationPaymentsStatus.PENDING]: ColorPalette.Default,
  };
  dateRangeType: DateRangeType = DateRangeType.ALL_TIME;
  startFrom: any = null;
  endAt: any = null;
  searchTerm: string;
  customerId: any = null;
  createdBy: any = null;
  currentIndex = 0;
  selectedIndex = 0;
  currentTabIndex: number;

  transportationPaymentsStatus: TransportationPaymentsStatus;
  Status = TransportationPaymentsStatus;

  tabs: TabModel[] = [
    {
      label: TransportationPaymentsStatus.ALL,
      showCount: true,
    },
    {
      label: TransportationPaymentsStatus.PENDING,
      showCount: true,
    },
    {
      label: TransportationPaymentsStatus.REJECTED,
      showCount: true,
    },
    {
      label: TransportationPaymentsStatus.PAID,
      showCount: true,
    },
  ];

  filterNavigationConfig: TabModel = {
    group: TabGroup.TransportationPayments,
    index: TabIndex.Shipments,
  };

  selectedElement: Shipment = new Shipment();
  @ViewChild('previewMarkModal')
  previewMarkModal: ModalComponent;

  actionType: string;
  paymentDetails: TransportationPaymentDetails = new TransportationPaymentDetails();
  selectedShipments: Shipment[] = [];

  @ViewChild('paymentConfirmationModal') paymentConfirmationModal;

  minimumStartDate: any;
  maximumEndDate: any;
  ShipmentAction = ShipmentAction;
  ShipmentSearchFields = ShipmentSearchFields;
  fleetId: number;
  searchKey: ShipmentSearchFields;
  @Output() emptyList = new EventEmitter();
  urlParamsForFiltration: any = null;
  @Output() exportClicked = new EventEmitter<void>();

  constructor(
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private transportationPaymentsCommonService: TransportationPaymentsCommonService
  ) {
    super();
  }

  ngOnInit(): void {
    this.getFleetId();
    this.subscribeToFilterChanges();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  getFleetId() {
    this.fleetId = Number(this.activatedRoute.snapshot.params?.fleetId);
  }

  getShipments() {
    this.load(
      this.transportationPaymentsCommonService.getTransportationPayments({
        fleetId: this.fleetId,
        customerId: this.customerId,
        createdBy: this.createdBy,
        paymentStatus: this.transportationPaymentsStatus,
        offset: this.offset,
        limit: this.pageSize,
        dateRangeType: this.dateRangeType,
        startFrom: this.startFrom,
        endAt: this.endAt,
        searchTerm: this.searchTerm,
        searchKey: this.searchKey,
      }),
      {
        contentPath: 'shipments',
      }
    ).subscribe((res) => {
      this.paymentDetails = res;
      this.setupTabsCount();
      switch (this.transportationPaymentsStatus) {
        case null:
          this.setupTable(this.paymentDetails.shipments, this.paymentDetails.totalCount);
          break;

        case TransportationPaymentsStatus.PENDING:
          this.setupTable(this.paymentDetails.shipments, this.paymentDetails.pendingCount);
          break;

        case TransportationPaymentsStatus.REJECTED:
          this.setupTable(this.paymentDetails.shipments, this.paymentDetails.rejectedCount);
          break;

        case TransportationPaymentsStatus.PAID:
          this.setupTable(this.paymentDetails.shipments, this.paymentDetails.paidCount);
          break;
      }
    });
  }

  subscribeToFilterChanges() {
    this.filterService.URLParams$.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      if (
        params &&
        params?.tabGroup == TabGroup.TransportationPayments &&
        params?.tabIndex == TabIndex.Shipments
      ) {
        this.urlParamsForFiltration = params;
        this.resetIndices();
        this.filterPayments(params);
      }
    });
  }

  filterPayments(params: any) {
    this.dateRangeType = params.dateRange;
    this.customerId = params.customerId == SharedConstants.ALL ? null : params.customerId;
    this.createdBy = params.creatorId == SharedConstants.ALL ? null : params.creatorId;
    this.startFrom = params.startFrom;
    this.endAt = params.endAt;
    if (params.fleetId) {
      this.fleetId = params.fleetId == SharedConstants.ALL ? null : params.fleetId;
    }
    this.getShipments();
  }

  resetIndices() {
    this.offset = ConfigConstant.INIT_PAGE_OFFSET;
    this.pageIndex = ConfigConstant.INIT_PAGE_INDEX;
  }

  setupTable(data: Shipment[], count: number) {
    this.dataSource.data = data;
    this.totalRowsCount = count;

    this.checkSelectedElements();

    if (!count) {
      this.sectionState = SectionStateStatus.Empty;
      this.emptyList.emit(true);
    } else {
      this.sectionState = SectionStateStatus.Ready;
      this.emptyList.emit(false);
    }
  }

  onPageIndexChange(index: number) {
    this.pageIndex = index;
    if (index > 1) {
      this.offset = index - 1;
    } else {
      this.offset = 0;
    }

    if (this.urlParamsForFiltration) {
      this.filterPayments(this.urlParamsForFiltration);
    } else {
      this.getShipments();
    }
  }

  onSearch(searchObj) {
    this.resetIndices();
    this.searchTerm = searchObj.searchTerm;
    this.searchKey = searchObj.searchKey;
    this.getShipments();
  }

  getCurrentTabIndex(event: number) {
    this.currentIndex = event;
    this.setStatus();
    this.resetIndices();
    if (this.urlParamsForFiltration) {
      this.filterPayments(this.urlParamsForFiltration);
    } else {
      this.getShipments();
    }
  }

  setStatus() {
    switch (this.currentIndex) {
      case 0:
        this.transportationPaymentsStatus = null;
        break;

      case 1:
        this.transportationPaymentsStatus = TransportationPaymentsStatus.PENDING;
        break;

      case 2:
        this.transportationPaymentsStatus = TransportationPaymentsStatus.REJECTED;
        break;

      case 3:
        this.transportationPaymentsStatus = TransportationPaymentsStatus.PAID;
        break;
    }
  }

  setupTabsCount() {
    this.tabs = this.tabs.map((tab: TabModel) => {
      switch (tab.label) {
        case TransportationPaymentsStatus.ALL:
          tab.count = this.paymentDetails.totalCount;
          break;

        case TransportationPaymentsStatus.PENDING:
          tab.count = this.paymentDetails.pendingCount;
          break;

        case TransportationPaymentsStatus.REJECTED:
          tab.count = this.paymentDetails.rejectedCount;
          break;

        case TransportationPaymentsStatus.PAID:
          tab.count = this.paymentDetails.paidCount;
          break;
      }
      return tab;
    });
  }

  onPreviewMarkModal(element: Shipment, type: string) {
    this.selectedElement = element;
    this.actionType = type;
    this.previewMarkModal.showModal();
  }

  reloadComponent() {
    this.getShipments();
  }

  markElement(event: MatCheckboxChange, shipment: Shipment) {
    if (event.checked) {
      this.selectedShipments.push(shipment);
    } else {
      this.selectedShipments = this.selectedShipments.filter(
        (element: Shipment) => element.id !== shipment.id
      );
    }
  }

  checkSelectedElements() {
    this.dataSource.data.forEach((element) => {
      if (
        this.selectedShipments
          .map((e) => {
            return e.id;
          })
          .indexOf(element.id) === -1
      ) {
        element.selected = false;
      } else {
        element.selected = true;
      }
    });
  }

  makeAPayment() {
    this.paymentConfirmationModal.showModal();
    let selectedShipmentsDates = this.selectedShipments.map((element) => element.updatedAt);
    this.minimumStartDate = new Date(Math.min(...selectedShipmentsDates));
    this.maximumEndDate = new Date(Math.max(...selectedShipmentsDates));
  }
  onExportClicked(): void {
    this.exportClicked.emit();
  }
}
